import React from 'react';
import ToolsMenu from '@/components/tools/ToolsMenu';
import DictionaryReportTools from './DictionaryReportTools';

const DictionaryReportToolsMenu = ({
  code,
  downloadStart,
  isDownloading,
  report,
  reportType,
  upward,
}) => (
  <ToolsMenu upward={upward}>
    <DictionaryReportTools
      code={code}
      downloadStart={downloadStart}
      isDownloading={isDownloading}
      report={report}
      reportType={reportType}
    />
  </ToolsMenu>
);
export default DictionaryReportToolsMenu;
